'use client';

import { initializedFromUrl, monthSelectionInitialized } from '@/store/brokerMetricsSlice';
import { useAppDispatch, useAppSelector } from '@/store/store';
import { parseBrokersParam } from '@/utils/convert';
import { thisWeekDateRange } from '@/utils/dateRangePicker';
import { useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import BrokerChartSection from './BrokerChartSection';
import BrokerStatsTable from './BrokerStatsTable';
import PromotionBanner from './PromotionBanner';

const KOTAK_BROKER_CODE = 'Kotak';

function BrokerMetrics() {
    const dispatch = useAppDispatch();
    const searchParams = useSearchParams();
    const initializedRef = useRef(false);
    const brokers = useAppSelector((state) => state.brokerMetrics.brokers);
    const endpoints = useAppSelector((state) => state.brokerMetrics.endpoints);

    useEffect(() => {
        if (initializedRef.current || brokers.length === 0 || endpoints.length === 0) {
            return;
        }
        initializedRef.current = true;

        const requestedEndpoint = searchParams.get('criteria');
        const endpoint = requestedEndpoint && endpoints.includes(requestedEndpoint) ? requestedEndpoint : endpoints[0];

        const requestedBrokers = parseBrokersParam(
            searchParams.get('brokers'),
            brokers.map((broker) => broker.code)
        );
        const hasKotakBroker = brokers.some((broker) => broker.code === KOTAK_BROKER_CODE);
        let initialBrokers = [brokers[0].code];
        if (requestedBrokers.length > 0) {
            initialBrokers = requestedBrokers;
        } else if (hasKotakBroker) {
            initialBrokers = [KOTAK_BROKER_CODE];
        }

        dispatch(initializedFromUrl({ endpoint, brokers: initialBrokers }));
        const weekRange = thisWeekDateRange();
        dispatch(
            monthSelectionInitialized({
                month: weekRange.start.slice(0, 7),
                range: weekRange,
            })
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [brokers, endpoints]);

    return (
        <div className='mt-5 flex w-full flex-col gap-4 md:gap-5'>
            <div className='flex flex-col gap-1.5 md:gap-2'>
                <h1 className='text-xl font-medium leading-7 text-[#2A2A2A] md:text-3xl md:font-semibold md:leading-tight md:tracking-tight'>
                    <span className='md:hidden'>Broker Speedtest</span>
                    <span className='hidden md:inline'>Broker Speedtest</span>
                </h1>
                <h2 className='text-xs font-normal leading-4 text-[#555] md:text-sm md:leading-normal md:text-slate-600'>
                    Live Broker API Response Time & Latency Comparison Across India&apos;s Leading Brokers
                </h2>
            </div>
            <div className='min-w-0 md:my-3'>
                <PromotionBanner />
            </div>
            <BrokerChartSection />
            <BrokerStatsTable />
        </div>
    );
}

export default BrokerMetrics;
